import { Authenticated, useList, useTranslate } from "@refinedev/core";
import { useOrganization } from "hooks/useOrganization";
import React, { useMemo } from "react";
import { BrandKit, PaletteResponse } from "../types";
import { BrandKitPanel } from "./components/BrandKitPanel";
import { PageLayout } from "components/PageLayout";

export type ViewMode = "table" | "grid" | "mockup";

export const colorKeys: (keyof PaletteResponse)[] = [
  "primary_color",
  "secondary_color",
  "title_color",
  "title_stroke_color",
  "subtitle_color",
  "subtitle_stroke_color",
  "highlight_color",
];

export const BrandKitList: React.FC = () => {
  const t = useTranslate();
  const { organization } = useOrganization({});
  const organizationId = organization?.id;

  const { data } = useList<BrandKit>({
    resource: `media/${organizationId}/brand_kits?include_generated=false`,
  });
  const sortedData = useMemo(
    () => data?.data.sort((a, b) => a.name.localeCompare(b.name)),
    [data?.data]
  );

  if (!sortedData || !organizationId) return null;

  return (
    <Authenticated key="brandkits">
      <PageLayout
        title={t("media.brandkit.index.header.title")}
        breadcrumbLabel={t("src.App.brandKits")}
      >
        <BrandKitPanel brandkits={sortedData} organizationId={organizationId} />
      </PageLayout>
    </Authenticated>
  );
};
